
//disable
function btnDisable () {
    var buttons = document.querySelectorAll('.payment-buttons .shopify-payment-button, .payment-buttons input[type="submit"], .disable-checkout');
        buttons.forEach(function(button) {
            button.setAttribute('disabled', 'true');
        });
}
//enable
function btnEnable () {
    var buttons = document.querySelectorAll('.payment-buttons .shopify-payment-button, .payment-buttons input[type="submit"], .disable-checkout');
      buttons.forEach( function(button) {
          button.removeAttribute('disabled');
      });
}

function disableLink(event) {
            event.preventDefault();
            alert("select DOB first and Chec term & condition.");
}
var cart_age;
  var cart_term;



document.addEventListener('DOMContentLoaded', function() {
  const cookies = getCookies();
  const overageCookie = cookies.overage;
  const underageCookie = cookies.underage;
  if (overageCookie && underageCookie === "false") {
    var cart_age_gate = document.getElementsByClassName('cart-agegate');
    if (cart_age_gate.length > 0) {
      cart_age_gate[0].style.display = 'none';
    }
    btnEnable();
  }else{
    btnDisable();
  }
});

const terms_check = document.getElementById('cart_register_terms_conditions');
if(terms_check){
  terms_check.disabled = true;
}

document.addEventListener('DOMContentLoaded', handleCookieLock);



const cart_dob = document.getElementById('cart-dob');
function applyDateMask(value) {
  return value
    .replace(/\D/g, '')
    .replace(/(\d{2})(\d)/, '$1/$2')
    .replace(/(\d{2})(\d)/, '$1/$2')
    .replace(/(\d{4})(\d)/, '$1');
}
if(cart_dob){
  cart_dob.addEventListener('input', function() {
  cart_dob.value = applyDateMask(cart_dob.value);
});
}



document.addEventListener("change", function (e) {
  const errorMessageDiv = document.getElementById('error-message');
  // const cart_dob = document.getElementById('cart-dob');
  const checkbox_buttons = document.querySelectorAll('.cartSummary');  

  let age;
  // if (e.target.type === 'date' && e.target.id === "cart-dob") {
  if (e.target.id === "cart-dob") {
    const dob = e.target.value;
    
  console.log('dob', dob);
  if (!dob.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
      e.preventDefault();
      errorMessageDiv.textContent = "Please enter a valid date in the format dd/mm/yyyy.";
      return;
    }

    age = calculateAge(dob);
    if (age < 13) {
      terms_check.disabled = true;
    } else {
      terms_check.disabled = false;
    }
  }

  let condition;
  if (e.target.type === 'checkbox' && e.target.id === 'cart_register_terms_conditions') {
    condition = e.target.checked;
  }
  
  if (age < 13) {
    e.preventDefault();
    checkbox_buttons.forEach(button => button.classList.add('disable'));
    cart_dob.disabled = true;
    terms_check.disabled = true;
    errorMessageDiv.textContent = "You must be 13 or older to make this purchase.";
    // document.cookie = "underage=true; path=/; max-age=2592000";  // 30 days 2592000
    // document.cookie = `underage_creation=${Date.now()}; path=/; max-age=2592000`; // Store creation time
  } else if (!condition) {
    if(errorMessageDiv){
       errorMessageDiv.textContent = "You must agree to the terms and conditions to proceed.";
    // document.cookie = "overage=true; path=/; max-age=2592000";  // 30 days 2592000
    btnDisable();
    }
   
  } else {
    errorMessageDiv.textContent = "";
    checkbox_buttons.forEach(button => button.classList.remove('disable'));
    btnEnable();
  }

  handleCookieLock();
});

// function calculateAge(birthdate) {
//   const birthDate = new Date(birthdate);
//   const today = new Date();
//   let age = today.getFullYear() - birthDate.getFullYear();
//   const monthDifference = today.getMonth() - birthDate.getMonth();

//   if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
//     age--;
//   }

//   return age;
// }


function calculateAge(birthdate) {
    const birthDateParts = birthdate.split('/');
    const birthDateObj = new Date(birthDateParts[2], birthDateParts[1] - 1, birthDateParts[0]);
    const today = new Date();
    let age = today.getFullYear() - birthDateObj.getFullYear();
    const monthDifference = today.getMonth() - birthDateObj.getMonth();

    if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDateObj.getDate())) {
      age--;
    }
    return age;
  }



function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

function calculateCookieAge() {
  const underageCookie = getCookie('underage_creation');
  if (underageCookie) {
    const creationTime = parseInt(underageCookie);
    const now = Date.now();
    const ageMilliseconds = now - creationTime;
    const ageDays = Math.floor(ageMilliseconds / (1000 * 60 * 60 * 24));
    return ageDays;
  }
  return null;
}

function getCookies() {
  return document.cookie.split('; ').reduce((acc, cookie) => {
    const [name, value] = cookie.split('=');
    acc[name] = value;
    return acc;
  }, {});
}

function handleCookieLock() {
  const cookies = getCookies();
  if (cookies.underage === "true") {
    const cookieAge = calculateCookieAge();
    if (cookieAge !== null) {
      const remainingDays = 30 - cookieAge;
      const cart_dob = document.getElementById('cart-dob');
      cart_dob.disabled = true;
      alert(`You have been locked for 30 days. Please try again after ${remainingDays} days.`);
    }
  }
}






// var age;
// var condition;
// var dob_location;
// var checkbox_location;

function cartLink() {
            var link = document.getElementById("cartSummary");
            link.classList.add('disable');
   }

$(document).ready(function(){
  var btnlink = $(".cartSummary");
  // $(".cartSummary").addClass("disable");
 
  // check email

  //end of check email
    
});
 $(document).on('click', function(event){
   if(event.target.type === "submit"){
     $(".cartSummary").addClass("disable");
   }
   // console.log(event.target.innerHTML);
   
    if(event.target.innerHTML=== "Quick buy"){
      setTimeout(btnDisable, 800);
    }



   
  });

//custome code
